import React from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { TodoCardProps } from "models/propTypes/todoPropTypes";
import { TranslationKeys } from "translations";
import { FormHandles } from "models/propTypes/genericFormProps";
import { BoardMemberFormTypes } from "models/formTypes";
//endregion
//#region components
import TopTodoCard from "../../_partials/topTodoCard";
import { TitledContainerInner, EntityCardContent } from "components/common";
import ExpandableSection from "components/common/wintForms/formSections/expandableSection";
import { UpdateBoardMembersDataFooter, useUpdateBoardMembersDataSnoozeAction } from "components/boardMember";
import { Grid } from "@mui/material";
import BoardMemberDetailsToDoFormContainer from "components/boardMember/forms/boardMemberDetailsToDoFormContainer";
//#endregion
import { DateHelper, LocalizationHelperInstance, UtilsHelper } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const UpdateBoardMembersDataTodo: React.FC<TodoCardProps> = (props) => {
  const companyName = useSelector((store: AppState) => store.auth.selectedCompany.name ?? "");
  const snoozeAction = useUpdateBoardMembersDataSnoozeAction(props.item.id, props.onActionSuccess);

  const formRef = React.useRef<FormHandles>(null);
  const [isDirty, setIsDirty] = React.useState<boolean>(false);

  const data: BoardMemberFormTypes.BoardMemberDisplay[] =
    props.item.updateNewBoardMembersData?.externalDirectors?.map((boardMember) => ({
      boardMember,
      socialSecurityNumber: boardMember.socialSecurityNumber ?? "",
      mail: boardMember.mail ?? "",
    })) ?? [];

  const onFormUpdate = (values: BoardMemberFormTypes.BoardMembersDisplay, isValid: boolean) => {
    const someEmailsFilled = isValid && (values.boardMembers?.some((b) => !UtilsHelper.isEmpty(b.mail)) ?? false);
    setIsDirty(isDirty || someEmailsFilled);
  };

  const submitBoardMembersDataToDoForm = (submitFunc?: (values: any) => Promise<any>) => {
    return (formRef.current && formRef.current.submit(submitFunc)) || new Promise<void>((resolve) => resolve());
  };

  return (
    <EntityCardContent
      topTodoCard={
        <TopTodoCard
          item={props.item}
          descriptionHeadingTwo={companyName}
          footerText={`${LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.Common.Latest
          )}: ${DateHelper.convertDateToShortISOString(DateHelper.addDays(new Date(), 10))}`}
          quickActions={[snoozeAction]}
          noDescriptionTextWrap
        />
      }
      todoMainSection={
        <TitledContainerInner
          header={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BoardMember.AddMissingInformation)}
          subHeader={LocalizationHelperInstance.getFormattedMessage(
            TranslationKeys.BoardMember.WeNeedCorrectContactInformation
          )}
        >
          <BoardMemberDetailsToDoFormContainer ref={formRef} boardMembers={data} onFormUpdate={onFormUpdate} />
          <ExpandableSection
            summary={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BoardMember.WhyIsThisNeeded)}
            initiallyOpen={false}
          >
            <Grid item container className={cssExports.contentFooterText}>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.BoardMember.WhyIsThisNeededDescription)}
            </Grid>
          </ExpandableSection>
        </TitledContainerInner>
      }
      footer={
        <UpdateBoardMembersDataFooter
          markAsDoneHandler={props.onActionSuccess}
          isDisabled={!isDirty}
          boardMembersDataToDoFormSubmitHandler={submitBoardMembersDataToDoForm}
        />
      }
    ></EntityCardContent>
  );
};

export default UpdateBoardMembersDataTodo;
